import { CouponType, UICouponType } from '@tencent/wphk-act-base-types';

/** 将原始值couponType map为UI的couponType */
export function mapCouponType(rawType?: CouponType): UICouponType {
  switch (rawType) {
    case CouponType.FIXED:
      return UICouponType.cash; // 现金券
    case CouponType.DISC:
      return UICouponType.discount; // 折扣券
    default:
      return UICouponType.default; // 默认
  }
}
